import { MentionsPlugin } from "../../../sked-editor/social-mention/mention-plugin";
import { isSuggestOptionTemplate } from "../../utils/autocomplete";
import { SuggestFunc } from "../types";
import { SkedMentionBox, SkedMentionItem } from "./sked-mention-box";

const MAX_TOOLTIP_LENGTH = 200;
export const TemplateSearchPlugin = ({
  lookupFunc,
}: {
  lookupFunc: SuggestFunc;
}) => {
  return (
    <MentionsPlugin
      menuBoxBehavior={{
        nodeConversion: {
          type: "plain-text",
          convertFunc: (item) => `${item.template}`,
        },

        dataFetcher: async (
          lookupText: string | null | undefined
        ): Promise<(SkedMentionItem & { template: string })[]> => {
          const rs = await lookupFunc(lookupText || "");
          return rs
            .filter((c) => isSuggestOptionTemplate(c))
            .map((c) => ({
              key: c._id,
              displayName: c.name,
              template: c.template,
              tooltip: `${c.template?.slice(0, MAX_TOOLTIP_LENGTH)}${c.template?.length > MAX_TOOLTIP_LENGTH ? "..." : ""}`,
            }));
        },
        renderMenuBox: (props, { lookupText }) => {
          return (
            <SkedMentionBox
              {...props}
              headingText="Templates"
              highlightBehavior={{
                matchingOn: "start",
                searchText: lookupText,
              }}
              displayConfig={{ showItemTooltip: true }}
            />
          );
        },
        maxItemsToShow: 100,
      }}
      lookupConfig={{
        allowWhitespace: true,
        trigger: "//",
        minLength: 1,
        maxLength: 100,
        typeDebounceTime: 200,
      }}
    />
  );
};
